import type { FC } from 'react';
import type { OrderWithActiveDelivery } from '../types';
import { ArrowRightCircleIcon } from '@heroicons/react/24/outline';
import { useNavigate } from 'react-router-dom';

interface ActiveDeliveriesTableProps {
    orders: OrderWithActiveDelivery[] | null;
    title?: string;
}

const TH = 'px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-stone-500';

const formatDate = (d?: string | null) => d ? new Date(d).toLocaleString() : '–';

const ActiveDeliveriesTable: FC<ActiveDeliveriesTableProps> = ({orders, title = 'Orders out for Delivery',}) => {
    const navigate = useNavigate();

    return (
        <section className="overflow-hidden rounded-2xl border border-stone-200 bg-white shadow-sm">
            <div className="px-5 py-3 border-b border-stone-200">
                <h2 className="font-semibold text-stone-900">{title}</h2>
            </div>
            {orders === null ? (
                <div className="p-4 text-sm text-stone-400">Loading…</div>
            ) : orders.length === 0 ? (
                <div className="p-4 text-sm text-stone-500">No active deliveries found.</div>
            ) : (
                <div className="overflow-x-auto">
                    <table className="w-full text-sm">
                        <thead className="bg-stone-50 border-b border-stone-200">
                        <tr>
                            <th className={TH}>Order Ref</th>
                            <th className={TH}>Customer</th>
                            <th className={TH}>Driver</th>
                            <th className={TH}>Assigned Date</th>
                            <th className="px-4 py-3" />
                        </tr>
                        </thead>
                        <tbody className="divide-y divide-stone-100">
                        {orders.map(order => (
                            <tr key={order.id}
                                onClick={() => navigate(`/orders/${order.id}`)}
                                className="cursor-pointer hover:bg-stone-50 transition">
                                <td className="px-4 py-3 font-medium text-stone-900">{order.order_reference}</td>
                                <td className="px-4 py-3 text-stone-700">{order.customer}</td>
                                <td className="px-4 py-3">
                                        <span className="border border-stone-300 px-2 py-0.5 text-xs text-stone-700 rounded-full inline-flex items-center gap-1.5">
                                            <span className="h-2 w-2 rounded-full bg-[#8dc63f] animate-pulse" />
                                            {order.driver_name}
                                        </span>
                                </td>
                                <td className="px-4 py-3 text-stone-500 text-xs">{formatDate(order.assigned_date)}</td>
                                <td className="px-4 py-3 text-right">
                                    <ArrowRightCircleIcon className="h-5 w-5 text-stone-400" />
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            )}
        </section>
    );
};

export default ActiveDeliveriesTable;